// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateOrganizationPopupFormSteps_wrapper__HZz2R"};